import './features.scss';

class Features {
    constructor ($element) {
        this.$features = $element;
    }

    initialize () {
        this.setHeadlineMargin();
        this.resizeFeatures();
    }

    setHeadlineMargin () {
        const windowWidth = window.innerWidth;
        const $featuresHeader = this.$features.querySelector('.features__header');

        if (windowWidth < 1024) {
            const $headline = this.$features.querySelector('.features__headline');
            const headlineWidth = $headline.offsetWidth;
            const featuresMargin = parseInt(window.getComputedStyle(this.$features).marginBottom.replace('px', ''));
            const $featuresItemList = this.$features.querySelector('.features__items-list');
            const featuresItemListPadding = parseInt(window.getComputedStyle($featuresItemList).paddingBottom.replace('px', ''));
            const $featureItems = this.$features.querySelectorAll('.features__item');
            const $lastFeatureItem = $featureItems[$featureItems.length - 1];
            const lastFeatureItemPadding = parseInt(window.getComputedStyle($lastFeatureItem).paddingBottom.replace('px', ''));
            const headlineMargin = headlineWidth + featuresMargin + featuresItemListPadding + lastFeatureItemPadding;
            $featuresHeader.style.marginBottom = headlineMargin + 'px';
        } else {
            $featuresHeader.style.marginBottom = 0;
        }
    }

    resizeFeatures () {
        window.resizeHandler.customFunctions.push(() => {
            this.setHeadlineMargin();
        });
    }
}

export { Features };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $features = $context.querySelectorAll('.features');
        if ($features.length > 0) {
            $features.forEach((featuresItem) => {
                const $featuresItem = new Features(featuresItem);
                $featuresItem.initialize();
            });
        }
    }
});
